import React, { useEffect, useRef, useState } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import { get } from "lodash";

import SearchInput from "../../atoms/SearchInput";
import DfpContainer from "../../ads/dfp-container";
import { DfpComponent } from "../../ads/dfp-component";
import SearchFilter from "../../molecules/SearchFilter";
import SearchStories1AdWithLoadMore from "../../rows/SearchStories1AdWithLoadMore";

import { staticTexts } from "../../utils/Translate";
import { fireVirtualPageOnSPA, getSlotId } from "../../utils/utils";

import "./search.m.css";

function SearchPageView({ data, lang = "bn" }) {
  const { query = {}, total } = data;
  const inputRef = useRef();
  const [inputFocus, setInputFocus] = useState(false);

  const ads = {
    R1: {
      en: "EnPalo_ROS_336x280_R1",
      bn: "News_336x280_R1",
    },
    R3: {
      en: "EnPalo_ROS_336x280_R3",
      bn: "News_336x280_R3",
    },
  };

  useEffect(() => {
    handleReload();
  }, []);

  useEffect(() => {
    const focusHandler = () => {
      setInputFocus(true);
    };
    const blurHandler = () => {
      setInputFocus(false);
    };

    if (inputRef && inputRef.current) {
      inputRef.current.addEventListener("focus", focusHandler);
      inputRef.current.addEventListener("blur", blurHandler);

      return () => {
        inputRef.current.removeEventListener("focus", focusHandler);
        inputRef.current.removeEventListener("blur", blurHandler);
      };
    }
  }, [inputRef]);

  const handleReload = () => {
    if (document.readyState === "complete") {
      fireVirtualPageOnSPA("Search", "Not Applicable", "", "");
    }
  };

  return (
    <div styleName="base">
      <h1 styleName="search-title">{staticTexts(lang).advanceSearch}</h1>
      <div styleName="container">
        <div styleName="main">
          <SearchInput
            className="search-input"
            inputClassName="search__form-input"
            styleName={`search-box ${inputFocus ? "search-active" : ""}`}
            defaultValue={query.q}
            inputRef={inputRef}
            query={query}
            isClear={true}
            lang={lang}
          />
          <div styleName="filter-box">
            <SearchFilter total={total} query={query} lang={lang} />
          </div>
          <SearchStories1AdWithLoadMore data={data} lang={lang} />
        </div>
        <div styleName="right-bar">
          <DfpContainer styleName="r2-ad">
            <DfpComponent
              type={global.isMobile ? ads.R3[lang] : ads.R1[lang]}
              slotId={getSlotId(global.isMobile ? ads.R3[lang] : ads.R1[lang], "Search-page", 2)}
            />
          </DfpContainer>
        </div>
      </div>
    </div>
  );
}

SearchPageView.propTypes = {
  data: object,
  lang: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

const SearchPage = connect(mapStateToProps)(SearchPageView);

export { SearchPage };
